import type { ServiceCode } from '@gov-nx/module/service';
import { useCmsStoreService } from '@gov-nx/store';

export interface CmsServiceProps {
	code: ServiceCode;
}

export const useCmsService = (props: CmsServiceProps) =>
	useCmsStoreService(props.code);
